import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {Appearance, ColorOption} from '../../../shared/models/appearance';
import {isValidTileColor} from '@shared/utils/color.util';

@Component({
  selector: 'motn-tile-icon',
  templateUrl: './tile-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tile-icon.component.scss'],
})
export class TileIconComponent {
  @Input() appearance: Appearance;

  get validColor(): ColorOption {
    return isValidTileColor(this.appearance?.Color || '');
  }
}
